module.exports = __webpack_public_path__ + "static/img/6.9caeb85.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/sp/6.png
// module id = uEFT
// module chunks = 0